import React from "react";

interface BoardLayoutProps {
  children: React.ReactNode;
  fill?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Shared layout for board pages (Projects, Makers)
 * Provides the common structure: section wrapper and content area
 */
export function BoardLayout({
  children,
  fill,
  className,
  style,
}: BoardLayoutProps) {
  return (
    <section
      className={`project-board${fill ? " project-board--fill" : ""}${className ? ` ${className}` : ""}`}
      style={style}
    >
      {children}
    </section>
  );
}
